import {
	TabbedForm,
	FormTab,
	TextInput,
	NumberInput,
	ReferenceInput,
	SelectInput,
	AutocompleteInput,
	DateInput,
	ImageInput,
	ImageField,
	ArrayInput,
	SimpleFormIterator,
	NullableBooleanInput,
	BooleanInput
} from "react-admin/lib";
import React from "react";

import { minValue, maxValue, notZero, required, isBool } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typeOwner } from "../../constant/TypeOwner";
import { typeRoomService } from "../../constant/TypeRoomService";

const validateEveryDate = [minValue(1), maxValue(31), notZero()];

const InterestingForm = props => {
	const { record } = props;
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};

	return (
		<TabbedForm {...props}>
			<FormTab label="room.tab.general">
				<ReferenceInput
					disabled={record.project ? true : false}
					validate={[required()]}
					source="project"
					reference="project"
					filter={filter}
				>
					<SelectInput optionText="name" />
				</ReferenceInput>
				<TextInput source="name" validate={[required()]} />
				<TextInput source="type" validate={[required()]} />
				<NumberInput source="area" validate={[required()]} />
				<SelectInput source="service_type" choices={typeRoomService} />
			</FormTab>
			<FormTab label="room.tab.owner">
				<ArrayInput source="users">
					<SimpleFormIterator>
						<ReferenceInput
							label="Email"
							source="id"
							reference="user"
							validate={[required()]}
						>
							<AutocompleteInput
								source="email"
								optionText={value => `${value.email} ${value.provider || ""}`}
							/>
						</ReferenceInput>
						<SelectInput
							validate={[required()]}
							source="type"
							label="Type"
							choices={typeOwner}
						/>
						<BooleanInput source="bookFacility" label="สามารถจองสิ่งอำนวยความสะดวกได้" />
					</SimpleFormIterator>
				</ArrayInput>
				{/* <ReferenceInput label="Email" source="user._id" reference="user" allowEmpty>
                    <AutocompleteInput source="email" optionText={value => `${value.email} ${value.provider || ''}`} />
                </ReferenceInput> */}
				<div style={{ height: 350 }} />
			</FormTab>
			<FormTab label="room.tab.images">
				<ImageInput multiple={true} source="images" accept="image/*">
					<ImageField source="url" title="Room images" />
				</ImageInput>
			</FormTab>
			{process.env.REACT_APP_ENVIRONMENT_ROOM_MENU !== undefined &&
				<FormTab label="room.tab.owner_menu">
					{process.env.REACT_APP_ENVIRONMENT_ROOM_MENU.split(",").map((value, index) =>
						<BooleanInput label={value} key={index} source={`optional.owner.${value}`} defaultValue={true} validate={[isBool()]} style={{ width: 256 }} />
					)}
				</FormTab>
			}

			{process.env.REACT_APP_ENVIRONMENT_ROOM_MENU !== undefined &&
				<FormTab label="room.tab.rent_menu">
					{process.env.REACT_APP_ENVIRONMENT_ROOM_MENU.split(",").map((value, index) =>
						<BooleanInput label={value} key={index} source={`optional.rent.${value}`} defaultValue={true} validate={[isBool()]} style={{ width: 256 }} />
					)}
				</FormTab>
			}



			{/* <FormTab label='payment'>
                <NumberInput label="จำนวนงวด" source="payment.period" />
                <NumberInput label="งวดละ" source="payment.monthly" />
                <DateInput label="เริ่มจ่ายวันที่" source="payment.start" />
                <NumberInput label="จ่ายทุกวันที่" source="payment.every_date" validate={validateEveryDate} />
            </FormTab> */}
			{/* <FormTab label='warranty'>
                <ArrayInput source="warranty">
                    <SimpleFormIterator>
                        <TextInput label="Name" source="name" />
                        <TextInput label="Shop bought" source="shop" />
                        <DateInput label="Expire date" source="expire" />
                        <ImageInput
                            multiple={true}
                            source="images" label="Images" accept="image/*">
                            <ImageField source="url" title="Images" />
                        </ImageInput>
                    </SimpleFormIterator>
                </ArrayInput>
            </FormTab> */}
		</TabbedForm>
	);
};

export default InterestingForm;



// WEBPACK FOOTER //
// ./src/components/room/RoomForm.js